export const convertToCurrencyString = (value: number): string => {
    return "Rs: " + value.toLocaleString(undefined, { minimumFractionDigits: 0 });
}